import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';

export type IdentificationErrorKind = 'locked' | 'canceled';

const useStyles = makeStyles(() =>
  createStyles({
    panel: {
      marginTop: 28,
      height: 298,
      background: '#ECEFF1',
      borderRadius: 14,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    },
    icon: {
      color: 'var(--color-sub)',
      fontSize: 144,
      marginTop: 8
    },
    caption: {
      marginTop: 8,
      fontSize: 16,
      textAlign: 'center'
    },
    smallCaption: {
      margin: 16,
      fontSize: 12
    },
    // キャンセルは本文が 2 行になるため左寄せにする
    smallCaptionCanceled: {
      margin: 16,
      fontSize: 12,
      alignSelf: 'stretch',
      textAlign: 'left'
    }
  })
);

interface Props {
  kind: IdentificationErrorKind;
}

const IdentificationErrorPanel: React.FC<Props> = ({ kind }) => {
  const styles = useStyles({});
  const isCanceled = kind === 'canceled';

  return (
    <div className={styles.panel}>
      <ReportProblemOutlinedIcon className={styles.icon} />
      {isCanceled ? (
        <>
          <p className={styles.caption}>ご契約はキャンセルされています</p>
          <p className={styles.smallCaptionCanceled}>
            契約がキャンセルされているため、お申込みいただけません。
            <br />
            ご不明な点は、物件の管理会社にお問い合わせください。
          </p>
        </>
      ) : (
        <>
          <p className={styles.caption}>ロックされています</p>
          <p className={styles.smallCaption}>
            入力された生年月日が一定回数連続して一致しなかったため、お申し込みをロックさせていただきました。
            <br />
            ロック解除については、物件の管理会社にお問い合わせください。
          </p>
        </>
      )}
    </div>
  );
};

export default IdentificationErrorPanel;
